const PRICING_PACKAGING_EVENTS = {
  plans: {
    viewed: true,
    clicked: true,
  },
};

export default PRICING_PACKAGING_EVENTS;
